import { SearchOrganizationResponse } from "../../main/models/search-organization-response";
import { get } from "./utils";

export const accountSearch = async (searchString: string) =>
  await get<SearchOrganizationResponse>(`search/account/${searchString}`);
